module.exports = __webpack_public_path__ + "img/btn_Topping_s.5cd2ed5f.png";